export default {
  subtitle: 'LaTeX, z którego tworzona jest treść raportu. Pozostaw puste, aby użyć domyślnej treści.',
};
